var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.boxStyle)},_vm._l((_vm.labels),function(label){return _c('a-tag',{key:'labels-' + label.id,attrs:{"color":label.color}},[_vm._v(_vm._s(label.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }